import React, { useRef, useCallback } from "react";
import LightGallery from "lightgallery/react";
import lgZoom from "lightgallery/plugins/zoom";
import lgVideo from "lightgallery/plugins/video";
import { GalleryContainer } from "../styles";
import { WorkProjectShell } from "./WorkProjectShell";
import {
  WorkSplitRow,
  WorkMediaFrame,
  WorkTextStack,
  WorkSectionHeading,
  StyledImageGrid,
  WorkGallerySection,
  WorkHighlightBand,
} from "./styles";
import { ProjectDetails } from "../../../DesignSystem/ProjectDetails";

export default function ARConnect() {
  const ProjectBG = require("../../../../assets/videos/ar-connect/poster.png");
  const Grid1 = require("../../../../assets/videos/ar-connect/t1.png");
  const Grid2 = require("../../../../assets/videos/ar-connect/t2.png");
  const Grid3 = require("../../../../assets/videos/ar-connect/t3.png");

  const lightGallery = useRef<any>(null);
  const items = [
    { id: "1", size: "1400-933", src: Grid1, thumb: Grid1, subHtml: `` },
    { id: "2", size: "1400-933", src: Grid2, thumb: Grid2, subHtml: `` },
    { id: "3", size: "1400-933", src: Grid3, thumb: Grid3, subHtml: `` },
  ];

  const onInit = useCallback((detail: any) => {
    if (detail) lightGallery.current = detail.instance;
  }, []);

  const getItems = useCallback(() => {
    return items.map((item) => (
      <a
        key={item.id}
        data-lg-size={item.size}
        className="gallery-item"
        data-src={item.src}
        href={item.src}
      >
        <img
          className="img-responsive w-100 rounded"
          src={item.thumb}
          alt="AR Connect gallery preview"
        />
      </a>
    ));
  }, [items]);

  return (
    <WorkProjectShell
      posterSrc={ProjectBG}
      title="Empowering remote collaboration with augmented reality"
      lead={
        <p>
          Welcome to AR Connect, a revolutionary application that harnesses
          the power of augmented reality to enable seamless remote collaboration.
          With AR Connect, geographical constraints no longer limit brand
          agents, product experts, customers, and field technicians from
          visually guiding and collaborating with each other.
        </p>
      }
    >
      <WorkSplitRow>
        <WorkMediaFrame>
          <video controls poster={Grid1}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/argo-hytos/1_ARConnect.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Engaging multimedia content</WorkSectionHeading>
          <p>
            AR Connect allows users to create virtual rooms and invite others to
            join. Once everyone has joined, users can place content in their
            respective locations, creating a shared augmented reality space.
            Users can see each other as avatars, promoting a sense of presence
            and enhancing collaboration. Communication is facilitated through
            voice, fostering real-time interactions, discussions, and
            presentations.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow $reverse>
        <WorkMediaFrame>
          <StyledImageGrid src={Grid2} alt="" />
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>
            Product demonstrations and remote assistance
          </WorkSectionHeading>
          <p>
            AR Connect serves as an exceptional tool for product demonstrations
            and remote assistance. Product experts can guide customers or field
            technicians through complex processes by visually overlaying
            instructions and information in the shared augmented reality
            environment. This immersive experience provides a unique and
            interactive way to collaborate, troubleshoot, and provide real-time
            assistance, regardless of physical location.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow>
        <WorkMediaFrame>
          <StyledImageGrid src={Grid3} alt="" />
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>
            Enhanced communication and collaboration
          </WorkSectionHeading>
          <p>
            AR Connect showcases the immense potential of augmented reality to
            enhance communication and collaboration across various fields. By
            seamlessly integrating virtual and physical spaces, it breaks down
            geographical barriers and enables experts and users to work together
            as if they were in the same location—improving efficiency, knowledge
            transfer, and teamwork.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkHighlightBand>
        <p>
          AR Connect is at the forefront of leveraging augmented reality to
          transform remote collaboration. By bridging physical distance and
          real-time interaction, it empowers users to collaborate effectively,
          demonstrate products remotely, and provide unparalleled assistance.
        </p>
      </WorkHighlightBand>

      <ProjectDetails
        details={[
          { label: "Project Name", value: "AR Connect" },
          { label: "Period", value: "04.2020 - 06.2020" },
          { label: "Client", value: "Radiusmedia KG" },
          {
            label: "Engine & Tools",
            value: "Unity, Photon, AR Foundation, C#",
          },
          { label: "Platform", value: "Mobile" },
          { label: "Company", value: "Radiusmedia KG" },
          { label: "Tags", value: "AR, Multi-user" },
        ]}
      />

      <WorkGallerySection>
        <GalleryContainer>
          <LightGallery
            plugins={[lgVideo, lgZoom]}
            elementClassNames="gallery-custom-wrapper row flex-column flex-sm-row"
            onInit={onInit}
            data-lg-size={2}
          >
            {getItems()}
          </LightGallery>
        </GalleryContainer>
      </WorkGallerySection>
    </WorkProjectShell>
  );
}
